import {
  Component,
  EventEmitter,
  Input,
  AfterContentChecked,
  Output,
  ChangeDetectorRef
} from "@angular/core";

@Component({
  selector: "checkbox",
  templateUrl: "./checkbox.component.html"
})
export class CheckboxComponent implements AfterContentChecked {
  public value;
  public status: string;
  public showLine = true;
  public showCross = false;
  public setInitialStatus;

  @Input() id;
  @Input() label;
  @Input() initialStatus;
  @Input() disabled = false;
  @Input() set initialRefresh(value: boolean) {
    if (this.setInitialStatus) this.setState();
    if (value) this.refresh.emit(false);
  }

  public constructor(private changeDetector: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
    if(!this.setInitialStatus) this.setState();
  }

  @Output() formValue = new EventEmitter<any>();
  @Output() refresh = new EventEmitter<boolean>(true);
  @Output() pristine = new EventEmitter<boolean>();

  public setState() {
    this.setInitialStatus = true;
    switch (this.initialStatus) {
      case "false": {
        this.status = "unchecked";
        (document.getElementById(this.id) as HTMLInputElement).checked = true;
        this.value = "false";
        this.showLine = false;
        this.showCross = true;
        break;
      }
      case "": {
        this.status = "indeterminate";
        (document.getElementById(this.id) as HTMLInputElement).indeterminate = true;
        this.value = "";
        this.showLine = true;
        this.showCross = false;
        break;
      }
      case "true": {
        this.status = "checked";
        (document.getElementById(this.id) as HTMLInputElement).checked = true;
        this.value = "true";
        this.showLine = false;
        this.showCross = false;
        break;
      }
    }
    this.initialStatus === this.value ? this.pristine.emit(true) : this.pristine.emit(false);
    this.formValue.emit(this.value);
  }

  public check(event: any) {
    if (this.disabled) {
      event.preventDefault();
      return;
    }
    
    switch (this.status) {
      case "checked": {
        this.status = "unchecked";
        event.target.checked = false;
        this.value = "false";
        this.showLine = false;
        this.showCross = true;
        break;
      }
      case "unchecked": {
        this.status = "indeterminate";
        event.target.indeterminate = true;
        this.value = "";
        this.showLine = true;
        this.showCross = false;
        break;
      }
      case "indeterminate": {
        this.status = "checked";
        event.target.checked = true;
        this.value = "true";
        this.showLine = false;
        this.showCross = false;
        break;
      }
    }
    this.initialStatus === this.value ? this.pristine.emit(true) : this.pristine.emit(false);
    this.formValue.emit(this.value);
  }
}
